import React, { useState } from "react";
import Burger from "../Burger/Burger";
import Menu from "../Menu/Menu";
import "./Header.css";
import { Link } from "gatsby";

//TODO: als je verder naar beneden scrollt verdwijnt de header, zodat je beeld rustig wordt.

const Header = (props) => {
  return (
    <>
      <div className="header">
        <Link to="/">
          <h1 className="heading">rvds</h1>
          <h6 className="heading">wijsheid van en voor de aarde</h6>
        </Link>
        <Menu />
      </div>
    </>
  );
};

export default Header;
